import { ApiClient, CafeListItemViewModel, StationViewModel } from "@dining/api-client";
import { IApplicationInsights } from "@microsoft/applicationinsights-web";
import dayjs from "dayjs";
import { LoaderFunctionArgs } from "react-router-dom";

export type CafeViewLoaderData = {
  cafe: CafeListItemViewModel;
  stations: StationViewModel[];
};

//If availability of both is not defined or is the same, then compare on names.
export const compareStations = (a: StationViewModel, b: StationViewModel) => {
  //If both the stations have undefined or defined but equal availability, check them based on their names
  return a.isAvailableOnline === b.isAvailableOnline
    ? a?.name?.localeCompare(b?.name)
    : Number(a.isAvailableOnline) * -1;
};
export const cafeViewLoader =
  (appInsights: IApplicationInsights, client: ApiClient, selectedDate: dayjs.Dayjs) =>
  async ({ params }: LoaderFunctionArgs): Promise<CafeViewLoaderData> => {
    const { cafeId } = params;
    const cafe = await client.getCafeById(cafeId!);
    let stations: StationViewModel[] = [];
    try {
      const rawStationList = await client.getCafeStationsList(
        cafeId!,
        dayjs(selectedDate).get("day"),
      );
      stations = rawStationList.items?.sort(compareStations) || [];
    } catch (error) {
      appInsights.trackException(
        { exception: error as Error },
        {
          method: "getCafeStationsList",
          cafeId,
          day: dayjs(selectedDate).get("day"),
        },
      );
    }

    return { cafe, stations };
  };
